const PAGE_PATH = [
    "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75",
    "A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625Z",
    "M7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Z",
    "m.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z"
].join("");
const CORNER_PATH = "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z";

interface SkillIconProps {
    // Sizes the glyph through CSS; without it the glyph keeps its 16px width and height attributes.
    className?: string;
}

export const SkillIcon = ({ className }: SkillIconProps = {}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="currentColor"
        aria-hidden="true"
        data-testid="skill-icon"
    >
        <path fillRule="evenodd" clipRule="evenodd" d={PAGE_PATH} />
        <path d={CORNER_PATH} />
    </svg>
);
